module.exports = __webpack_public_path__ + "static/img/kjfw_2.4aca0ac8.png";